import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TransactionItemResponse } from '@api-client/mobipay';
import { ROUTES } from '@app/app.routes-constants';

@Injectable()
export class TransactionNavigationService {
  protected readonly router = inject(Router);

  public navigateToTransaction(
    transaction: TransactionItemResponse
  ): Promise<boolean> {
    if (!transaction?.id) {
      console.warn('Cannot navigate: Invalid invoice or missing ID');
      return Promise.resolve(false);
    }

    const navigationCommands = this.getNavigationCommands(transaction);
    if (!navigationCommands) {
      return Promise.resolve(false);
    }

    return this.router.navigate(navigationCommands);
  }

  private getNavigationCommands(
    transaction: TransactionItemResponse
  ): unknown[] | null {
    switch (transaction.detailScreenType) {
      case 'TRANSACTION_INVOICE_EDIT':
        return [ROUTES.TRANSACTION.EDIT(transaction.id)];
      case 'GROUPED_INVOICE_EDIT':
        return [ROUTES.TRANSACTION.EDIT_GROUPED(transaction.id)];
      default:
        console.error('Unknown detail screen type:', transaction.detailScreenType);
        return null;
    }
  }
}